<template>
  <div class="meal-choose" v-if="mealList.length>0">
    <h6>智工嗨搜产品 海外会员特享购</h6>
    <div class="meal-choose-ul">
      <!-- 1 -->
      <div class="li" v-if="false">
        <img src="@/assets/image/boot-page/setpackage_1.png" alt="" />
        <h5 class="meal-item-title">海外检索引擎+EDM邮件+客户管理</h5>
        <span class="meal-item-desc">提供定向开发与运营海外客户的理想选择</span>
        <div class="meal-item-package">
          <div class="package-original">
            <span class="package-original-currency">￥</span>
            <span class="package-original-value">{{ mealList[0].totalPrice | currency }}</span>
          </div>
          <!-- <div class="package-temp">
            <span v-if="userInfo.leadsStatus != 8" class="package-temp-msg">会员限时价</span>
            <span v-else class="package-temp-msg">限时体验价</span>
            <div class="package-temp-box">
              <span class="package-temp-currency">￥</span>
              <span class="package-temp-value">{{ mealList[0].kitPrice | currency }}</span>
            </div>
          </div> -->
        </div>
        <div class="meal-item-b">
          <ul class="meal-item-detail">
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">智工嗨搜产品功能包</span>
              <span class="meal-item-detail-item-value">基础版</span>
            </li>
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">信用点</span>
              <span class="meal-item-detail-item-value">2千点</span>
            </li>
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">EDM邮件数量</span>
              <span class="meal-item-detail-item-value">1万封</span>
            </li>
          </ul>
          <el-button 
            @click="purchase(0)"
            class="meal-item-buying" 
            type="primary"
            size="40px"
          >立即购买</el-button>
        </div>
      </div>

      <!-- 2 -->
      <div class="li only">
        <img src="@/assets/image/boot-page/setpackage_2.png" alt="" />
        <h5 class="meal-item-title">海外检索引擎+EDM邮件+客户管理</h5>
        <span class="meal-item-desc">提供定向开发与运营海外客户的理想选择</span>
        <div class="meal-item-package">
          <div class="package-original">
            <span class="package-original-currency">￥</span>
            <span class="package-original-value">{{ mealList[1].totalPrice | currency }}</span>
          </div>
          <!-- <div class="package-temp">
            <span v-if="userInfo.leadsStatus != 8" class="package-temp-msg">会员限时价</span>
            <span v-else class="package-temp-msg">限时体验价</span>
            <div class="package-temp-box">
              <span class="package-temp-currency">￥</span>
              <span class="package-temp-value">{{ mealList[1].kitPrice | currency }}</span>
            </div>
          </div> -->
        </div>
        <div class="meal-item-b">
          <ul class="meal-item-detail">
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">智工嗨搜产品功能包</span>
              <span class="meal-item-detail-item-value">基础版</span>
            </li>
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">信用点</span>
              <span class="meal-item-detail-item-value">5千点</span>
            </li>
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">EDM邮件数量</span>
              <span class="meal-item-detail-item-value">2万封</span>
            </li>
          </ul>
          <el-button 
            @click="purchase(1)"
            class="meal-item-buying" 
            type="primary"
            size="40px"
          >立即购买</el-button>
        </div>
      </div>

      <!-- 3 -->
      <div class="li" v-if="false">
        <img src="@/assets/image/boot-page/setpackage_3.png" alt="" />
        <h5 class="meal-item-title">海外检索引擎+EDM邮件+客户管理</h5>
        <span class="meal-item-desc">提供定向开发与运营海外客户的理想选择</span>
        <div class="meal-item-package">
          <div class="package-original">
            <span class="package-original-currency">￥</span>
            <span class="package-original-value">{{ mealList[2].totalPrice | currency }}</span>
          </div>
          <!-- <div :class="{'package-temp': true, 'is-expired': userInfo.leadsStatus == 8}">
            <span v-if="userInfo.leadsStatus != 8" class="package-temp-msg">会员限时价</span>
            <span v-else class="package-temp-msg">限时体验价</span>
            <div class="package-temp-box">
              <span class="package-temp-currency">￥</span>
              <span class="package-temp-value">{{ mealList[2].kitPrice | currency }}</span>
            </div>
          </div> -->
        </div>
        <div class="meal-item-b">
          <ul class="meal-item-detail">
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">智工嗨搜产品功能包</span>
              <span class="meal-item-detail-item-value">基础版</span>
            </li>
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">信用点</span>
              <span class="meal-item-detail-item-value">1万点</span>
            </li>
            <li class="meal-item-detail-item">
              <i class="iconfont icon-icon-feiloukong"></i>
              <span class="meal-item-detail-item-label">EDM邮件数量</span>
              <span class="meal-item-detail-item-value">5万封</span>
            </li>
          </ul>
          <el-button 
            @click="purchase(2)"
            class="meal-item-buying" 
            type="primary"
            size="40px"
          >立即购买</el-button>
        </div>
      </div>
    </div>

    <div class="meal-choose-explain">
      <h6>查看版本功能</h6>
      <Table />
    </div>

    <div class="declaration">
      <h6>大家都在问</h6>
      <b>海外采购数据从哪里来的?</b>
      <p>【智工嗨搜】的海外采购数据的联系方式来自全网公开信息，包括电话、邮箱等联系方式，可以帮助销售人员快速找到目标企业负责人，节省查找时间，助您有效拓客。</p>
    </div>
  </div>
</template>

<script>
import { getSubscribeKitList } from '@/utils/api/order'
import { onlineUrl } from '@/utils/config.js'
import Table from './components/Table'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    Table,
  },
  computed: {
    ...mapState('orderInfo', ['packages']),
    ...mapState(['userInfo']),
  },
  data() {
    return {
      mealList: [],
      onlineUrl,
    }
  },
  methods: {
    ...mapMutations('orderInfo', ['SET_PACKAGES']),
    async initData() {
      try {
        const res = await getSubscribeKitList()
        if (res.rspResult.bizCode === 200) {
          this.mealList = res.rspListData.list
          this.SET_PACKAGES(this.mealList || null)
        }
      } catch (err) {
        console.error("❌ ~ file: meal-choose.vue:200 ~ initData ~ err:", err)
      }
    },

    // 点击购买
    purchase(index) {
      this.$router.push({
        path: 'order-submission',
        query: {
          type: index,
          origin: 1,
        },
      })
    },

    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 1) {
    //     return {
    //       rowspan: 2,
    //       colspan: 2,
    //     }
    //   } else {
    //     return {
    //       rowspan: 2,
    //       colspan: 2,
    //     }
    //   }
    // },
  },
  created() {
    // 如果vuex里面有存，直接取
    // 💣💣💣价格会根据leadsStatus动态变化，所以必须每次重新请求
    if (false && this.packages && this.packages.length) {
      this.mealList = this.packages
    } else {
      this.initData()
    }
  },
}
</script>

<style lang="scss" scoped>
.meal-choose {
  padding-top: 95px;
  min-height: 1000px;
  text-align: center;
  background-image: url('~@/assets/image/boot-page/mealChoose_background.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #fff;
  > h6 {
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 24px;
    color: #16181a;
    margin-bottom: 61px;
  }
  
  &-ul {
    display: flex;
    justify-content: center;
    .li {
      &:hover {
        top: -20px;
      }
      top: 0;
      transition: all 0.5s ease;
      position: relative;
      margin-right: 40px;
      width: 320px;
      height: 429px;
      background: #ffffff;
      box-shadow: 0 0 20px 0 #003c981a;
      border-radius: 8px;
      box-sizing: border-box;
      padding-top: 54px;
      .meal-item-title {
        height: 16px;
        line-height: 16px;
        font-family: SourceHanSansCN-Bold;
        font-weight: 700;
        font-size: 16px;
        color: #16181A;
        letter-spacing: 0;
        margin-bottom: 12px;
        text-align: center;
      }
      .meal-item-desc {
        height: 12px;
        line-height: 12px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #16181A;
        letter-spacing: 0;
        text-align: center;
      }
      > img {
        position: absolute;
        width: 64px;
        right: 0;
        z-index: 2;
        top: 12px;
        background: #0BB976;
        border-radius: 0 0 0 8px;
      }
      .meal-item-package {
        width: 236px;
        height: 72px;
        box-sizing: border-box;
        margin: 20px auto 0;
        // background-image: linear-gradient(90deg, rgba(71, 160, 255, 0.1) 0%, rgba(49, 140, 237, 0.1) 100%);
        border-radius: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        // padding: 0 20px;
        user-select: none;
        .package-original {
          color: #318CED;
          &-currency {
            font-size: 12px;
            display: inline-block;
            transform-origin: right;
            transform: scale(0.83);
          }
          &-value {
            // font-size: 20px;
            font-size: 32px;
            font-weight: bold;
          }
        }
        .package-temp {
          margin-left: 16px;
          height: 57px;
          background-image: linear-gradient(90deg, #47A0FF 0%, #318CED 100%);
          border-radius: 16px;
          box-sizing: border-box;
          text-align: left;
          padding: 4px 24px 0;
          color: #FFF;
          &-msg {
            width: 60px;
            height: 20px;
            line-height: 20px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 12px;
            letter-spacing: 0;
          }
          &-box {
            .package-temp-currency {
              font-size: 12px;
              font-weight: 100;
              margin-right: 1px;
            }
            .package-temp-value {
              font-size: 22px;
              line-height: 25px;
              font-weight: bold;
            }
          }
        }
      }
      .meal-item-b {
        width: 248px;
        margin: 0 auto;
        // background: #eee;
        height: 200px;
        .meal-item-detail {
          padding: 24px 30px 16px;
          text-align: left;
          &-item {
            height: 14px;
            line-height: 14px;
            margin-bottom: 12px;
            display: flex;
            .iconfont {
              font-size: 14px;
              color: #318CED;
              margin-right: 8px;
            }
            &-label {
              height: 12px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              font-size: 12px;
              color: #16181A;
              letter-spacing: 0;
            }
            &-value {
              margin-left: auto;
              height: 14px;
              font-family: SourceHanSansCN-Medium;
              // font-weight: 700;
              font-size: 12px;
              color: #16181A;
              letter-spacing: 0;
            }
          }

        }
        .meal-item-buying {
          padding: 13px 20px;
          width: 100%;
          background-image: linear-gradient(90deg, #47A0FF 0%, #318CED 100%);
          background-size: 100%;
          border: 0;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          font-size: 14px;
          color: #FFF;
          letter-spacing: 0;
        }
      }
      &:nth-child(2), &.only {
        width: 500px;
        > img {
          width: 96px;
          top: -10px;
          right: 7px;
          border-radius: 0;
          background: none;
        }
        .meal-item-package {
          // background-image: linear-gradient(79deg, rgba(241, 128, 29, 0.1) 0%, rgba(255, 71, 81, 0.1) 100%);
          .package-original {
            color: #F86337;
          }
          .package-temp {
            background-image: linear-gradient(79deg, #F1801D 0%, #FF4751 100%);
          }
        }
        .meal-item-b {
          .meal-item-detail {
            &-item {
              .iconfont {
                color: #FF774D;
              }
            }
          }
        }
        .meal-item-buying {
          background-image: linear-gradient(79deg, #F1801D 0%, #FF4751 100%);
        }
        &::after {
          // width: 328px;
          left: -4px;
          right: -4px;
          height: 16px;
          background-image: linear-gradient(79deg, #F1801D 0%, #FF4751 100%);
          background-size: 100%;
          border-radius: 8px;
        }
      }
      &:nth-child(3) {
        > img {
          width: 54px;
          background: #F56C6C;
          border-radius: 0 0 0 8px;
        }
        .meal-item-package {
          // background-image: linear-gradient(79deg, rgba(32, 55, 103, 0.1) 0%, rgba(51, 45, 115, 0.1) 100%);
          .package-original {
            color: #2A326D;
          }
          .package-temp {
            background-image: linear-gradient(-83deg, #203767 0%, #3A3384 100%);
            color: #FBE9BB;
            &.is-expired {
              padding: 4px 20px 0;
            }
          }
        }
        .meal-item-b {
          .meal-item-detail {
            &-item {
              .iconfont {
                color: #2A326D;
              }
            }
          }
        }
        .meal-item-buying {
          background-image: linear-gradient(-83deg, #203767 0%, #3A3384 100%);
          color: #FBE9BB;
        }
        &::after {
          background-image: linear-gradient(79deg, #203767 0%, #332D73 100%);
          background-size: 100%;
        }
      }
      &:last-child {
        margin-right: 0;
      }
      &::after {
        content: " ";
        position: absolute;
        left: -8px;
        right: -8px;
        top: 0;
        // width: 336px;
        height: 12px;
        background-image: linear-gradient(90deg, #F1F4FF 0%, #E4EAFF 100%);
        background-size: 100%;
        border-radius: 6px;
      }
    }
  }
  &-explain {
    h6 {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 24px;
      color: #16181a;
      margin: 100px 0 40px 0;
    }
  }

  .declaration {
    width: 1040px;
    margin: 0 auto;
    padding-bottom: 61px;
    >h6 {
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 14px;
      color: #16181A;
      letter-spacing: 0;
      text-align: justify;
      height: 14px;
      line-height: 14px;
    }
    >b {
      display: block;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181A;
      letter-spacing: 0;
      text-align: justify;
      height: 14px;
      line-height: 14px;
      margin-top: 12px;
      margin-bottom: 12px;
    }
    >p {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #4F5D78;
      letter-spacing: 0;
      text-align: justify;
      height: 14px;
      line-height: 20px;
    }
  }
}
</style>
